import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "حساب الفرق بين تاريخين أو عمرين في الهجري";
const DESCRIPTION =
  "حساب المدة بين تاريخين بالهجري بدقة. تعرض لك الحاسبة الفرق بالسنوات والشهور والأيام والساعات والدقائق والثواني، مع معلومات تفصيلية إضافية.";
const KEYWORDS =
  "إحسب الفرق بين عمرين هجري, احسب الفرق بين تاريخين هجري, حاسبة الفرق الزمني هجري, الفرق بين تاريخين بالهجري, حساب العمر هجري";
const OG_URL = "https://do-calculate.com/calculator/ar/datehijridifferences/";

// أسماء الأشهر الهجرية
const HIJRI_MONTHS = [
  "محرم", "صفر", "ربيع الأول", "ربيع الآخر", "جمادى الأولى", "جمادى الآخرة",
  "رجب", "شعبان", "رمضان", "شوال", "ذو القعدة", "ذو الحجة"
];

function DateDifferencesCalculatorHijri() {
  const [d1, setD1] = useState({ day: "1", month: "1", year: "1445" });
  const [d2, setD2] = useState({ day: "1", month: "1", year: "1446" });
  const [differences, setDifferences] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const calculateDifferences = () => {
    setIsLoading(true);
    setError(null);

    // تحويل المدخلات لأرقام
    let day1 = parseInt(d1.day), month1 = parseInt(d1.month), year1 = parseInt(d1.year);
    let day2 = parseInt(d2.day), month2 = parseInt(d2.month), year2 = parseInt(d2.year);

    // ترتيب التواريخ (الأصغر أولاً)
    let start = { y: year1, m: month1, d: day1 };
    let end = { y: year2, m: month2, d: day2 };

    if (year1 > year2 || (year1 === year2 && month1 > month2) || (year1 === year2 && month1 === month2 && day1 > day2)) {
      start = { y: year2, m: month2, d: day2 };
      end = { y: year1, m: month1, d: day1 };
    }

    // حساب الفرق الهجري التقريبي
    let diffYears = end.y - start.y;
    let diffMonths = end.m - start.m;
    let diffDays = end.d - start.d;

    if (diffDays < 0) {
      diffMonths--;
      diffDays += 30; // الشهر الهجري غالباً 29 أو 30
    }
    if (diffMonths < 0) {
      diffYears--;
      diffMonths += 12;
    }

    // حساب الإحصائيات (تقريبية للتقويم الهجري: السنة الهجرية ≈ 354.36 يوم)
    const totalDays = Math.floor(diffYears * 354.36 + diffMonths * 29.53 + diffDays);
    const totalHours = totalDays * 24;
    const totalMinutes = totalHours * 60;
    const totalSeconds = totalMinutes * 60;

    setDifferences({
      years: diffYears,
      months: diffMonths,
      days: diffDays,
      totalDays,
      totalWeeks: Math.floor(totalDays / 7),
      totalMonths: diffYears * 12 + diffMonths,
      totalHours,
      totalMinutes,
      totalSeconds,
      startDate: `${start.d} ${HIJRI_MONTHS[start.m - 1]} ${start.y}`,
      endDate: `${end.d} ${HIJRI_MONTHS[end.m - 1]} ${end.y}`,
      workDays: Math.floor((totalDays / 7) * 5)
    });

    setIsLoading(false);
  };

  const renderSelectGroup = (data, setData, label) => (
    <div className="mb-4">
      <label ><strong>{label}:</strong></label>
      <div className="row">
        <div className="col-md-4">
          <select className="form-control" value={data.day} onChange={(e) => setData({ ...data, day: e.target.value })}>
            {Array.from({ length: 30 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.month} onChange={(e) => setData({ ...data, month: e.target.value })}>
            {HIJRI_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.year} onChange={(e) => setData({ ...data, year: e.target.value })}>
            {Array.from({ length: 100 }, (_, i) => 1500 - i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>
    </div>
  );

  return (
    <div className="rtl" style={{ direction: "rtl", textAlign: "right" }}>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />

      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
          <br />
          <div className="bg-success text-white text-center p-3 rounded shadow-sm">
            <h1 style={{ fontSize: "20px", margin: 0 }}>{TITLE}</h1>
          </div>

          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <p className="mb-4">
              هذه الحاسبة مخصصة لحساب الفرق بين تاريخين في <strong>التقويم الهجري</strong>. أدخل التاريخين أدناه للحصول على النتيجة بالسنوات والشهور والأيام والدقائق.
            </p>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle mb-4 p-3 bg-light rounded border">
              <div className="p-2 mb-4 bg-success text-white text-center rounded">
                <strong>أدخل التواريخ بالهجري</strong>
              </div>

              {renderSelectGroup(d1, setD1, "التاريخ الهجري الأول")}
              {renderSelectGroup(d2, setD2, "التاريخ الهجري الثاني")}

              <div className="text-center mt-4">
                <button className="btn btn-success btn-lg px-5" onClick={calculateDifferences} disabled={isLoading}>
                  {isLoading ? "جاري الحساب..." : "احسب الفرق الآن"}
                </button>
              </div>

              {error && <div className="alert alert-danger mt-3">{error}</div>}

              {differences && (
                <div className="mt-5 animate__animated animate__fadeIn">
                  <div className="alert alert-success border-success">
                    <h3 style={{ fontSize: "18px" }}><strong>نتيجة حساب الفرق بين التاريخين الهجريين:</strong></h3>
                    <div className="p-3 bg-white rounded border mt-3 text-center">
                      <strong className="text-muted">الفرق هو:</strong>
                      <div style={{ fontSize: "24px", color: "#28a745", fontWeight: "bold" }}>
                        {differences.years} سنة و {differences.months} شهر و {differences.days} يوم
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>الفرق بالتفصيل الهجري</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled lh-lg">
                            <li>✓ السنوات الهجرية: {differences.years}</li>
                            <li>✓ الأشهر الهجرية: {differences.months}</li>
                            <li>✓ الأيام: {differences.days}</li>
                            <li>✓ الساعات: {differences.totalHours.toLocaleString()}</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>إحصائيات إجمالية</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled lh-lg">
                            <li>📅 إجمالي الأيام: {differences.totalDays.toLocaleString()} يوم</li>
                            <li>📅 إجمالي الأسابيع: {differences.totalWeeks.toLocaleString()} أسبوع</li>
                            <li>📅 إجمالي الأشهر: {differences.totalMonths.toLocaleString()} شهر</li>
                            <li>⏰ إجمالي الساعات: {differences.totalHours.toLocaleString()} ساعة</li>
                            <li>⏰ إجمالي الدقائق: {differences.totalMinutes.toLocaleString()} دقيقة</li>
                            <li>💼 أيام العمل تقريباً: {differences.workDays.toLocaleString()} يوم</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card mb-3 shadow-sm border-0 bg-light">
                    <div className="card-body text-center">
                      <p className="mb-1"><strong>من:</strong> {differences.startDate} هـ</p>
                      <p className="mb-0"><strong>إلى:</strong> {differences.endDate} هـ</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <RelatedLinks />
          </div>
        </div>

        <div className="col-md-4">
          <SecondAds />
          <MainCalculatorsList />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                الفرق بين تاريخين في التقويم الميلادي: حساب الفارق العمري بين
                شخصين{" "}
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    العمر بالتاريخ الهجري: تحويل وحساب دقيق{" "}
                  </h2>{" "}
                </u>
                <p>
                  العمر هو جانب مهم في حياة الإنسان، وهو يعكس تجربته ونضوجه على
                  مر الزمن. يتطلب حساب الفرق بين تاريخين في التقويم الميلادي
                  معرفة دقيقة بالتواريخ والقدرة على تحويلها إلى فارق زمني بسيط.
                  في هذه المقالة، سنلقي نظرة على كيفية حساب الفرق العمري بين
                  شخصين أو بين تواريخ معينة في التقويم الميلادي.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    المفهوم الأساسي لحساب الفرق العمري
                  </h2>{" "}
                </u>
                <p>
                  حساب الفرق بين الأعمار هو عملية تحديد عدد السنوات والأشهر
                  والأيام التي تفصل بين تاريخين معينين في التقويم الميلادي. يمكن
                  استخدام هذا الحساب في العديد من السياقات مثل حساب فرق العمر
                  بين شخصين، أو معرفة فرق السن بين تواريخ مهمة مثل التخرج، أو أي
                  مناسبة أخرى.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيفية حساب الفرق العمري بين تواريخ ميلاد
                  </h2>{" "}
                </u>
                <p>
                  لحساب الفرق العمري بين تواريخ ميلاد معينة في التقويم الميلادي،
                  يمكنك اتباع الخطوات التالية:
                </p>
                <ul>
                  <li>
                    تحديد التواريخ: ابدأ بتحديد التواريخ التي تريد حساب الفرق
                    بينها.
                  </li>
                  <li>
                    تحويل التواريخ إلى أيام: قم بتحويل كل تاريخ إلى عدد من
                    الأيام ببساطة. على سبيل المثال، يمكنك تحويل كل تاريخ إلى عدد
                    من الأيام من بداية التقويم.
                  </li>
                  <li>
                    حساب الفارق: اطرح عدد الأيام الواحد من الآخر للحصول على
                    الفرق العمري بالأيام.
                  </li>
                  <li>
                    تحويل الفارق العمري: يمكن تحويل الفارق العمري بالأيام إلى
                    أشهر أو سنوات بالقسمة على عدد الأيام في الشهر أو السنة. على
                    سبيل المثال، هناك حوالي 30 يومًا في شهر.
                  </li>
                </ul>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    ستخدامات حساب الفرق العمري{" "}
                  </h2>{" "}
                </u>
                <p>
                  يمكن استخدام حساب الفرق العمري في العديد من السياقات مثل حساب
                  فرق العمر بين شخصين في علاقة، أو لتحديد فارق السن بين تواريخ
                  مهمة مثل تاريخ الزواج أو تاريخ الانتقال إلى منزل جديد. كما
                  يمكن استخدامه في الجوانب الإدارية والإحصائية.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيفية استخدام حاسبة الفرق بين عمرين او تاريخين في التقويم
                    الهجري{" "}
                  </h2>{" "}
                </u>
                <p>
                  تعود استخدام التقويم الهجري لحساب عمر الإنسان إلى التاريخ
                  الإسلامي. التقويم الهجري يستند إلى هجرة النبي محمد صلى الله
                  عليه وسلم من مكة إلى المدينة في عام 622. يتكون العام الهجري من
                  12 شهرًا، ويختلف عدد أيام كل شهر حسب التقويم الهجري. العام
                  الهجري أقصر من العام الميلادي، وبالتالي يختلف التاريخ في
                  العامين. <br />
                </p>
                <p>
                  تهدف هذه الحاسبة إلى حساب الفروق بين تاريخين في التقويم
                  الهجري. يتم تمرير التاريخين إلى الحاسبة على أنهما تواريخ
                  هجرية، مثل تاريخ الميلاد وتاريخ اليوم الحالي. <br />
                </p>
                <p>
                  عند التنفيذ تقوم الحاسبة بمقارنة التاريخين وحساب الفروق في
                  السنوات، الشهور، الأيام، الساعات، الدقائق، والثواني بينهما.
                  بمجرد الانتهاء، ستحصل على قيم تمثل الفروق في كل وحدة زمنية.{" "}
                  <br />
                </p>{" "}
                ,
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>اسئلة متكررة</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هو حساب الفرق بين عمرين في التقويم الهجري؟
                </h3>
              </div>
              <div className="info-section-body">
                حساب الفرق بين عمرين في التقويم الهجري هو عملية تحديد الفارق
                الزمني بين تواريخ ميلاد هؤلاء الأشخاص في هذا التقويم. يمكن أن
                يكون هذا الفارق بالأعوام والأشهر والأيام.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يمكن حساب الفرق بين عمرين في التقويم الهجري؟
                </h3>
              </div>
              <div className="info-section-body">
                يمكنك حساب الفرق بين عمرين أو تاريخين في التقويم الهجري باتباع
                الخطوات التالية:
                <ol>
                  <li>
                    تحديد تواريخ الميلاد للشخصين أو التواريخ التي تريد حساب
                    الفرق بينها.
                  </li>
                  <li>
                    تحويل تلك التواريخ إلى تواريخ هجرية باستخدام جداول التحويل
                    أو الأدوات المتاحة عبر الإنترنت.
                  </li>
                  <li>طرح التواريخ الهجرية للحصول على الفرق بالأيام.</li>
                  <li>تحويل الفرق بالأيام إلى أعوام وأشهر إذا كنت ترغب.</li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل هناك حاسبة لحساب الفرق بين عمرين في التقويم الهجري؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، يمكنك العثور على حاسبات عبر الإنترنت تساعدك في حساب الفرق
                بين تاريخين في التقويم الهجري بشكل سريع وبسيط. كل ما عليك هو
                إدخال التواريخ الهجرية وستحصل على الفرق بدقة.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هي أهمية حساب الفرق بين عمرين في التقويم الهجري؟
                </h3>
              </div>
              <div className="info-section-body">
                حساب الفرق بين عمرين أو تاريخين في التقويم الهجري يمكن أن يكون
                مفيدًا في العديد من السياقات. يمكنك معرفة الفرق بين أعمار
                الأشخاص أو معرفة مدى الزمن بين مناسبات هامة مثل الزواج أو لأغراض
                أخرى.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكن حساب الفرق بين عمرين في التقويم الهجري يدويًا؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، يمكن حساب الفرق بين عمرين في التقويم الهجري يدويًا بمعرفة
                التواريخ الهجرية وباستخدام القوانين الميلادية المعترف بها. الأمر
                يتطلب بعض الوقت والجهد، لكنه ممكن من الناحية الفنية.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DateDifferencesCalculatorHijri;
